// @generated by protobuf-ts 2.8.2 with parameter output_javascript
// @generated from protobuf file "zammad.proto" (syntax proto3)
// tslint:disable
// @generated by protobuf-ts 2.8.2 with parameter output_javascript
// @generated from protobuf file "zammad.proto" (syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
// @generated message type with reflection information, may provide speed optimized methods
class CreateTicketRequest$Type extends MessageType {
    constructor() {
        super("CreateTicketRequest", [
            { no: 1, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "group", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "group_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "customer_email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "subject", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "body", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "body_content_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "priority", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "priority_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "state", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "state_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "attachments", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Attachment },
            { no: 13, name: "note", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "tags", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "article_internal", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = { title: "", group: "", groupId: 0, customerEmail: "", subject: "", body: "", bodyContentType: "", priority: "", priorityId: 0, state: "", stateId: 0, attachments: [], note: "", tags: [], articleInternal: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string title */ 1:
                    message.title = reader.string();
                    break;
                case /* string group */ 2:
                    message.group = reader.string();
                    break;
                case /* int32 group_id */ 3:
                    message.groupId = reader.int32();
                    break;
                case /* string customer_email */ 4:
                    message.customerEmail = reader.string();
                    break;
                case /* string subject */ 5:
                    message.subject = reader.string();
                    break;
                case /* string body */ 6:
                    message.body = reader.string();
                    break;
                case /* string body_content_type */ 7:
                    message.bodyContentType = reader.string();
                    break;
                case /* string priority */ 8:
                    message.priority = reader.string();
                    break;
                case /* int32 priority_id */ 9:
                    message.priorityId = reader.int32();
                    break;
                case /* string state */ 10:
                    message.state = reader.string();
                    break;
                case /* int32 state_id */ 11:
                    message.stateId = reader.int32();
                    break;
                case /* repeated Attachment attachments */ 12:
                    message.attachments.push(Attachment.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string note */ 13:
                    message.note = reader.string();
                    break;
                case /* repeated string tags */ 14:
                    message.tags.push(reader.string());
                    break;
                case /* bool article_internal */ 15:
                    message.articleInternal = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string title = 1; */
        if (message.title !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.title);
        /* string group = 2; */
        if (message.group !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.group);
        /* int32 group_id = 3; */
        if (message.groupId !== 0)
            writer.tag(3, WireType.Varint).int32(message.groupId);
        /* string customer_email = 4; */
        if (message.customerEmail !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.customerEmail);
        /* string subject = 5; */
        if (message.subject !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.subject);
        /* string body = 6; */
        if (message.body !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.body);
        /* string body_content_type = 7; */
        if (message.bodyContentType !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.bodyContentType);
        /* string priority = 8; */
        if (message.priority !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.priority);
        /* int32 priority_id = 9; */
        if (message.priorityId !== 0)
            writer.tag(9, WireType.Varint).int32(message.priorityId);
        /* string state = 10; */
        if (message.state !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.state);
        /* int32 state_id = 11; */
        if (message.stateId !== 0)
            writer.tag(11, WireType.Varint).int32(message.stateId);
        /* repeated Attachment attachments = 12; */
        for (let i = 0; i < message.attachments.length; i++)
            Attachment.internalBinaryWrite(message.attachments[i], writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* string note = 13; */
        if (message.note !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.note);
        /* repeated string tags = 14; */
        for (let i = 0; i < message.tags.length; i++)
            writer.tag(14, WireType.LengthDelimited).string(message.tags[i]);
        /* bool article_internal = 15; */
        if (message.articleInternal !== false)
            writer.tag(15, WireType.Varint).bool(message.articleInternal);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateTicketRequest
 */
export const CreateTicketRequest = new CreateTicketRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateTicketWithTokenRequest$Type extends MessageType {
    constructor() {
        super("CreateTicketWithTokenRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "subject", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "body", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "body_content_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "group", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "group_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "priority", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "priority_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "attachments", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Attachment },
            { no: 11, name: "tags", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = { token: "", title: "", subject: "", body: "", bodyContentType: "", group: "", groupId: 0, priority: "", priorityId: 0, attachments: [], tags: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string title */ 2:
                    message.title = reader.string();
                    break;
                case /* string subject */ 3:
                    message.subject = reader.string();
                    break;
                case /* string body */ 4:
                    message.body = reader.string();
                    break;
                case /* string body_content_type */ 5:
                    message.bodyContentType = reader.string();
                    break;
                case /* string group */ 6:
                    message.group = reader.string();
                    break;
                case /* int32 group_id */ 7:
                    message.groupId = reader.int32();
                    break;
                case /* string priority */ 8:
                    message.priority = reader.string();
                    break;
                case /* int32 priority_id */ 9:
                    message.priorityId = reader.int32();
                    break;
                case /* repeated Attachment attachments */ 10:
                    message.attachments.push(Attachment.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated string tags */ 11:
                    message.tags.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string title = 2; */
        if (message.title !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.title);
        /* string subject = 3; */
        if (message.subject !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.subject);
        /* string body = 4; */
        if (message.body !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.body);
        /* string body_content_type = 5; */
        if (message.bodyContentType !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.bodyContentType);
        /* string group = 6; */
        if (message.group !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.group);
        /* int32 group_id = 7; */
        if (message.groupId !== 0)
            writer.tag(7, WireType.Varint).int32(message.groupId);
        /* string priority = 8; */
        if (message.priority !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.priority);
        /* int32 priority_id = 9; */
        if (message.priorityId !== 0)
            writer.tag(9, WireType.Varint).int32(message.priorityId);
        /* repeated Attachment attachments = 10; */
        for (let i = 0; i < message.attachments.length; i++)
            Attachment.internalBinaryWrite(message.attachments[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* repeated string tags = 11; */
        for (let i = 0; i < message.tags.length; i++)
            writer.tag(11, WireType.LengthDelimited).string(message.tags[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateTicketWithTokenRequest
 */
export const CreateTicketWithTokenRequest = new CreateTicketWithTokenRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Attachment$Type extends MessageType {
    constructor() {
        super("Attachment", [
            { no: 1, name: "filename", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "content", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 3, name: "mime_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = { filename: "", content: new Uint8Array(0), mimeType: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string filename */ 1:
                    message.filename = reader.string();
                    break;
                case /* bytes content */ 2:
                    message.content = reader.bytes();
                    break;
                case /* string mime_type */ 3:
                    message.mimeType = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string filename = 1; */
        if (message.filename !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.filename);
        /* bytes content = 2; */
        if (message.content.length)
            writer.tag(2, WireType.LengthDelimited).bytes(message.content);
        /* string mime_type = 3; */
        if (message.mimeType !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.mimeType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Attachment
 */
export const Attachment = new Attachment$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateTicketResponse$Type extends MessageType {
    constructor() {
        super("CreateTicketResponse", [
            { no: 1, name: "ticket_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "ticket_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "customer_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "group_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "priority_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "state_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "updated_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = { ticketId: 0, ticketNumber: "", title: "", customerId: 0, groupId: 0, priorityId: 0, stateId: 0, createdAt: "", updatedAt: "", success: false, message: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 ticket_id */ 1:
                    message.ticketId = reader.int32();
                    break;
                case /* string ticket_number */ 2:
                    message.ticketNumber = reader.string();
                    break;
                case /* string title */ 3:
                    message.title = reader.string();
                    break;
                case /* int32 customer_id */ 4:
                    message.customerId = reader.int32();
                    break;
                case /* int32 group_id */ 5:
                    message.groupId = reader.int32();
                    break;
                case /* int32 priority_id */ 6:
                    message.priorityId = reader.int32();
                    break;
                case /* int32 state_id */ 7:
                    message.stateId = reader.int32();
                    break;
                case /* string created_at */ 8:
                    message.createdAt = reader.string();
                    break;
                case /* string updated_at */ 9:
                    message.updatedAt = reader.string();
                    break;
                case /* bool success */ 10:
                    message.success = reader.bool();
                    break;
                case /* string message */ 11:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 ticket_id = 1; */
        if (message.ticketId !== 0)
            writer.tag(1, WireType.Varint).int32(message.ticketId);
        /* string ticket_number = 2; */
        if (message.ticketNumber !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ticketNumber);
        /* string title = 3; */
        if (message.title !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.title);
        /* int32 customer_id = 4; */
        if (message.customerId !== 0)
            writer.tag(4, WireType.Varint).int32(message.customerId);
        /* int32 group_id = 5; */
        if (message.groupId !== 0)
            writer.tag(5, WireType.Varint).int32(message.groupId);
        /* int32 priority_id = 6; */
        if (message.priorityId !== 0)
            writer.tag(6, WireType.Varint).int32(message.priorityId);
        /* int32 state_id = 7; */
        if (message.stateId !== 0)
            writer.tag(7, WireType.Varint).int32(message.stateId);
        /* string created_at = 8; */
        if (message.createdAt !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.createdAt);
        /* string updated_at = 9; */
        if (message.updatedAt !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.updatedAt);
        /* bool success = 10; */
        if (message.success !== false)
            writer.tag(10, WireType.Varint).bool(message.success);
        /* string message = 11; */
        if (message.message !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateTicketResponse
 */
export const CreateTicketResponse = new CreateTicketResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetGroupsRequest$Type extends MessageType {
    constructor() {
        super("GetGroupsRequest", [
            { no: 1, name: "active_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = { activeOnly: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool active_only */ 1:
                    message.activeOnly = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool active_only = 1; */
        if (message.activeOnly !== false)
            writer.tag(1, WireType.Varint).bool(message.activeOnly);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetGroupsRequest
 */
export const GetGroupsRequest = new GetGroupsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetGroupsResponse$Type extends MessageType {
    constructor() {
        super("GetGroupsResponse", [
            { no: 1, name: "groups", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ZammadGroup },
            { no: 2, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = { groups: [], success: false, message: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ZammadGroup groups */ 1:
                    message.groups.push(ZammadGroup.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool success */ 2:
                    message.success = reader.bool();
                    break;
                case /* string message */ 3:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ZammadGroup groups = 1; */
        for (let i = 0; i < message.groups.length; i++)
            ZammadGroup.internalBinaryWrite(message.groups[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool success = 2; */
        if (message.success !== false)
            writer.tag(2, WireType.Varint).bool(message.success);
        /* string message = 3; */
        if (message.message !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetGroupsResponse
 */
export const GetGroupsResponse = new GetGroupsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ZammadGroup$Type extends MessageType {
    constructor() {
        super("ZammadGroup", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "note", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = { id: 0, name: "", active: false, note: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* bool active */ 3:
                    message.active = reader.bool();
                    break;
                case /* string note */ 4:
                    message.note = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* bool active = 3; */
        if (message.active !== false)
            writer.tag(3, WireType.Varint).bool(message.active);
        /* string note = 4; */
        if (message.note !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.note);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ZammadGroup
 */
export const ZammadGroup = new ZammadGroup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPrioritiesRequest$Type extends MessageType {
    constructor() {
        super("GetPrioritiesRequest", [
            { no: 1, name: "active_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = { activeOnly: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool active_only */ 1:
                    message.activeOnly = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool active_only = 1; */
        if (message.activeOnly !== false)
            writer.tag(1, WireType.Varint).bool(message.activeOnly);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetPrioritiesRequest
 */
export const GetPrioritiesRequest = new GetPrioritiesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPrioritiesResponse$Type extends MessageType {
    constructor() {
        super("GetPrioritiesResponse", [
            { no: 1, name: "priorities", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ZammadPriority },
            { no: 2, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = { priorities: [], success: false, message: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ZammadPriority priorities */ 1:
                    message.priorities.push(ZammadPriority.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool success */ 2:
                    message.success = reader.bool();
                    break;
                case /* string message */ 3:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ZammadPriority priorities = 1; */
        for (let i = 0; i < message.priorities.length; i++)
            ZammadPriority.internalBinaryWrite(message.priorities[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool success = 2; */
        if (message.success !== false)
            writer.tag(2, WireType.Varint).bool(message.success);
        /* string message = 3; */
        if (message.message !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetPrioritiesResponse
 */
export const GetPrioritiesResponse = new GetPrioritiesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ZammadPriority$Type extends MessageType {
    constructor() {
        super("ZammadPriority", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "default_create", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = { id: 0, name: "", defaultCreate: false, active: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* bool default_create */ 3:
                    message.defaultCreate = reader.bool();
                    break;
                case /* bool active */ 4:
                    message.active = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* bool default_create = 3; */
        if (message.defaultCreate !== false)
            writer.tag(3, WireType.Varint).bool(message.defaultCreate);
        /* bool active = 4; */
        if (message.active !== false)
            writer.tag(4, WireType.Varint).bool(message.active);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ZammadPriority
 */
export const ZammadPriority = new ZammadPriority$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStatesRequest$Type extends MessageType {
    constructor() {
        super("GetStatesRequest", [
            { no: 1, name: "active_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = { activeOnly: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool active_only */ 1:
                    message.activeOnly = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool active_only = 1; */
        if (message.activeOnly !== false)
            writer.tag(1, WireType.Varint).bool(message.activeOnly);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetStatesRequest
 */
export const GetStatesRequest = new GetStatesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStatesResponse$Type extends MessageType {
    constructor() {
        super("GetStatesResponse", [
            { no: 1, name: "states", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ZammadState },
            { no: 2, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = { states: [], success: false, message: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ZammadState states */ 1:
                    message.states.push(ZammadState.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool success */ 2:
                    message.success = reader.bool();
                    break;
                case /* string message */ 3:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ZammadState states = 1; */
        for (let i = 0; i < message.states.length; i++)
            ZammadState.internalBinaryWrite(message.states[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool success = 2; */
        if (message.success !== false)
            writer.tag(2, WireType.Varint).bool(message.success);
        /* string message = 3; */
        if (message.message !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetStatesResponse
 */
export const GetStatesResponse = new GetStatesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ZammadState$Type extends MessageType {
    constructor() {
        super("ZammadState", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "default_create", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = { id: 0, name: "", defaultCreate: false, active: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* bool default_create */ 3:
                    message.defaultCreate = reader.bool();
                    break;
                case /* bool active */ 4:
                    message.active = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* bool default_create = 3; */
        if (message.defaultCreate !== false)
            writer.tag(3, WireType.Varint).bool(message.defaultCreate);
        /* bool active = 4; */
        if (message.active !== false)
            writer.tag(4, WireType.Varint).bool(message.active);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ZammadState
 */
export const ZammadState = new ZammadState$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HealthCheckRequest$Type extends MessageType {
    constructor() {
        super("HealthCheckRequest", []);
    }
    create(value) {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        return target ?? this.create();
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message HealthCheckRequest
 */
export const HealthCheckRequest = new HealthCheckRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HealthCheckResponse$Type extends MessageType {
    constructor() {
        super("HealthCheckResponse", [
            { no: 1, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "zammad_reachable", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = { status: "", version: "", zammadReachable: false, message: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string status */ 1:
                    message.status = reader.string();
                    break;
                case /* string version */ 2:
                    message.version = reader.string();
                    break;
                case /* bool zammad_reachable */ 3:
                    message.zammadReachable = reader.bool();
                    break;
                case /* string message */ 4:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string status = 1; */
        if (message.status !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.status);
        /* string version = 2; */
        if (message.version !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.version);
        /* bool zammad_reachable = 3; */
        if (message.zammadReachable !== false)
            writer.tag(3, WireType.Varint).bool(message.zammadReachable);
        /* string message = 4; */
        if (message.message !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message HealthCheckResponse
 */
export const HealthCheckResponse = new HealthCheckResponse$Type();
/**
 * @generated ServiceType for protobuf service ZammadService
 */
export const ZammadService = new ServiceType("ZammadService", [
    { name: "CreateTicket", options: {}, I: CreateTicketRequest, O: CreateTicketResponse },
    { name: "CreateTicketWithToken", options: {}, I: CreateTicketWithTokenRequest, O: CreateTicketResponse },
    { name: "GetGroups", options: {}, I: GetGroupsRequest, O: GetGroupsResponse },
    { name: "GetPriorities", options: {}, I: GetPrioritiesRequest, O: GetPrioritiesResponse },
    { name: "GetStates", options: {}, I: GetStatesRequest, O: GetStatesResponse },
    { name: "HealthCheck", options: {}, I: HealthCheckRequest, O: HealthCheckResponse }
]);
